import React from "react";
import styles from "./PrivacyPolicy.module.css";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      
      {/* Header */}
      <div className={styles.header}>
        <button onClick={() => navigate('/subscribe')} className={styles.backBtn}>←</button> 

        <div>
          <h1>Terms & Privacy Policy</h1>
          <p className={styles.lastUpdated}>Last Updated: 1-Nov-2026</p>
        </div>
      </div>

      {/* Content */}
      <div className={styles.content}>
        
        {/* =======================
            TERMS AND CONDITIONS 
            ======================= */}
        <h2 style={{ fontSize: '22px', borderBottom: '1px solid #333', paddingBottom: '10px' }}>
          Terms and Conditions
        </h2>
        
        <h3>1. Description of Service</h3>
        <p>
          <strong>Game Plex</strong> is a digital service that allows SLT Mobitel 
          customers to play HTML5 games with different categories.
        </p>

        <h3>2. Cost</h3>
        <p>Game Plex service will cost you:</p>
        <ul>
          <li><strong>NGN 10</strong> for prepaid users</li>
          <li><strong>NGN 300</strong> for postpaid users</li>
        </ul>

        <br />
        <br />

        {/* =======================
            PRIVACY POLICY 
            ======================= */}
        <h2 style={{ fontSize: '22px', borderBottom: '1px solid #333', paddingBottom: '10px' }}>
          Privacy Policy
        </h2>

        <h3>1. Personal Information We Collect</h3>
        <ul>
          <li>Your Mobile number</li>
          <li>Your subscription type and payment channel i.e. Airtime</li>
          <li>Customer care information through your contact with us</li>
          <li>Information about your usage of the App, such as how often you use it or when you dismiss alerts</li>
          <li>The level of service that you receive – for example, delivery reports, delays or service faults and other events that may affect our services</li>
        </ul>

        <h3>2. When we collect your personal information</h3>
        <ul>
          <li>When you first subscribe to the service</li>
          <li>When you use the Game Plex service and any of its features</li>
          <li>When you contact our customer care teams with a query</li>
        </ul>

        <h3>3. How We Use Your Information</h3>
        <ul>
          <li>To help us identify you</li>
          <li>To provide you access to the service</li>
          <li>Billing and customer care</li>
          <li>To notify you of any changes to the services that may affect you</li>
          <li>Identity verification</li>
        </ul>

        <h3>4. Marketing and Profiling</h3>
        <p>
          If you are opted into marketing and have given us permission to use your data 
          to tailor these communications, we’ll use your interactions with this portal to 
          inform the sorts of marketing we should be sending you so that it’s the most 
          relevant for you.
        </p>
        
        <h3>5. How to opt out</h3>
        <p>
          To opt out of Marketing messages or profiling: If you no longer want to receive 
          marketing messages from SLT Mobitel or Bharat Tech Solutions, you can elect to 
          opt out of all marketing communications or only selected methods (email, messaging, 
          phone or post).
        </p>
        <ul>
          <li>Contact our customer care team</li>
          <li>All our marketing messages come with an “unsubscribe” link which you can click to unsubscribe</li>
          <li>Tell the adviser you no longer want to be marketed to, if you receive an outbound marketing call</li>
        </ul>
        <p>
          <em>Opting out does not mean that you won’t any longer receive service-related 
          messages, such as messages telling you about your order status or when our Terms 
          and Conditions change. You will still continue to receive those (unless we have 
          indicated otherwise). You may also receive marketing via push notifications if 
          you have not turned them off via your App settings</em>
        </p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;